import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '../config/FirebaseConfig';
import toCamelCase from '../logic/toCamelCase';
import { Participant } from '../data/classes/Participant';

const FetchAllParticipants = async (type: "Vendor" | "Artist"): Promise<Participant[]> => {
  try {
    const collectionName = type === "Vendor" ? "Vendors" : "Artists";
    const participantsRef = collection(firestore, collectionName);
    const querySnapshot = await getDocs(participantsRef);
    
    const participants: Participant[] = querySnapshot.docs.map(docSnap =>
      toCamelCase({ id: docSnap.id, ...docSnap.data() }) as Participant
    );

    return participants;
  } catch (error) {
    console.error(`Error fetching ${type.toLowerCase()}s: `, error);
    return [];
  }
};

export default FetchAllParticipants;
